import type { CorridorUnavailableReason } from "@/shared/services/payments/paymentCorridors.service";

import type { SendRail } from "./walletSend";

export type ColombiaRailUnavailableKey =
  | "col_rail_unavailable"
  | "col_rail_not_configured"
  | "col_rail_balance_low"
  | "col_rail_balance_low_try_breb";

/**
 * The line under a Colombian payout rail that cannot be picked, by why. Three different next actions: a rail
 * switched off is "try later", one without configuration is a state of the account, and one whose float is
 * short is temporarily disabled with another rail to use right now — Transfiya and Bre-B are paid from
 * separate floats, so Bre-B keeps working while Transfiya is short.
 */
export function colombiaRailUnavailableKey(
  rail: SendRail,
  reason: CorridorUnavailableReason | null,
): ColombiaRailUnavailableKey {
  if (reason === "provider_balance_low") {
    return rail === "TRANSFIYA" ? "col_rail_balance_low_try_breb" : "col_rail_balance_low";
  }
  return reason === "rail_disabled" ? "col_rail_unavailable" : "col_rail_not_configured";
}
